import { useEffect, useState, useMemo } from 'react'

interface IMobileProps {
  widthOfMobile?: number
  widthOfMiddleDevice?: number
  callbackForResizeWindow?: (event?: UIEvent) => void
}

// Безопасная проверка ширины окна (для SSR)
const getWindowWidth = () => (typeof window !== 'undefined' ? window.innerWidth : 0)

export const useIsMobile = ({
  widthOfMobile,
  widthOfMiddleDevice,
  callbackForResizeWindow,
}: IMobileProps = {}) => {
  const [isMobileByWidth, setIsMobileByWidth] = useState<boolean>(
    getWindowWidth() < (widthOfMobile || 770),
  )
  const [isMiddleDeviceByWidth, setIsMiddleDeviceByWidth] = useState<boolean>(
    getWindowWidth() < (widthOfMiddleDevice || 1440),
  )

  useEffect(() => {
    // Обновляем значения после монтирования
    setIsMobileByWidth(window.innerWidth < (widthOfMobile || 770))
    setIsMiddleDeviceByWidth(window.innerWidth < (widthOfMiddleDevice || 1440))

    const handleResizeWindow = (event?: UIEvent) => {
      setIsMobileByWidth(window.innerWidth < (widthOfMobile || 770))
      setIsMiddleDeviceByWidth(window.innerWidth < (widthOfMiddleDevice || 1440))

      if (callbackForResizeWindow) {
        callbackForResizeWindow(event)
      }
    }

    window.addEventListener('resize', handleResizeWindow)

    return () => {
      window.removeEventListener('resize', handleResizeWindow)
    }
  }, [widthOfMobile, widthOfMiddleDevice, callbackForResizeWindow])

  const isMobileByUserAgent = useMemo(
    () => typeof navigator !== 'undefined' && /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
    [],
  )

  // Проверка на in-app браузер (Telegram, VK, WhatsApp, etc.)
  const isInAppBrowser = useMemo(
    () => typeof navigator !== 'undefined' && /FBAN|FBAV|Instagram|WhatsApp|Telegram|VKontakte|VKCOM/i.test(navigator.userAgent),
    [],
  )

  return { isMobileByWidth, isMiddleDeviceByWidth, isMobileByUserAgent, isInAppBrowser }
}
